(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({ note: event.target.value });
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss_share_follow_reel"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.getElementById('shopify-section-{{ section.id }}');
  if(!root) return;
  const video = root.querySelector('video#reel-{{ section.id }}');
  const toggleBtn = root.querySelector('[data-toggle]');
  if(!video) return;

  // iOS/Chrome autoplay safety: ensure muted & playsinline
  video.muted = true; video.playsInline = true; video.setAttribute('webkit-playsinline','true');

  const setIcon = (playing) => {
    if(!toggleBtn) return;
    toggleBtn.innerHTML = playing
      ? '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 5h3v14H8zM13 5h3v14h-3z" fill="currentColor"/></svg>'
      : '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 5l11 7-11 7V5z" fill="currentColor"/></svg>'
  }

  const playSafe = () => video.play().catch(()=>{});

  // Click to toggle
  const toggle = () => { if(video.paused){ playSafe(); setIcon(true); } else { video.pause(); setIcon(false);} };
  video.addEventListener('click', toggle);
  if(toggleBtn) toggleBtn.addEventListener('click', toggle);

  // Auto update icon
  video.addEventListener('play', () => setIcon(true));
  video.addEventListener('pause', () => setIcon(false));

  // Auto-pause when scrolled far away (minor perf)
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ playSafe(); } else { video.pause(); } });
  },{threshold:.4});
  io.observe(video);
})();

  } catch(e) { console.error(e); }
})();
})();
